import React from 'react'
import DashboardLayout from './DashboardLayout';

const Tools = () => {
  return (
    <DashboardLayout>
    <div className="main-content">Tools</div>
    </DashboardLayout>
  )
}

export default Tools;